<template>
    <div class="onboarding-step onboarding-step-welcome onboarding-step-final flex">
        <svg-vue class="onboarding-thank-you" icon="onboarding-thank-you" />
        <div class="content">
            <svg-vue class="logo-onboarding" icon="logo-onboarding" />
            <p class="header">
                All done! Thanks so much for sharing about you and your podcast.
            </p>
            <p class="text">
                We’d love to stay connected with you, to share news, answer questions, and generally be helpful.
            </p>
            <p class="text">
                Make sure to follow us on <a href="https://www.instagram.com/fusebox.fm/" target="_blank">Instagram</a> and <a href="https://twitter.com/FuseboxFM" target="_blank">Twitter</a>.
            </p>
            <onboarding-controls>
                <template v-slot:button>
                    Done! Take me to the dashboard.
                </template>
            </onboarding-controls>
        </div>
    </div>
</template>

<script>
import OnboardingControls from './OnboardingControls.vue';

export default {
    components: {
        OnboardingControls,
    },
};
</script>
